import { gql } from '@apollo/client';

export const PAYMENT_PLAN_TYPE_QUERY = gql`
 query financialProduct($productId: Int!) {
    financialProduct(productId: $productId) {
      leasingFinancialProduct{
        scheduleTypeId
      }
    }
  }
`;

export const FINANCIAL_PRODUCT_SEASONALITY_TEMPLATES_DICTIONARY_QUERY = gql`
  query financialProductSeasonalityTemplatesDictionary($paymentPlanType: Int) {
    financialProductSeasonalityTemplatesDictionary(paymentPlanType: $paymentPlanType) {
      templateId
      templateName
    }
  }
`;
